import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "types/store";
import * as reportReducer from "containers/Report/ReportReducer";
import { Button } from "@/aible";
import moment from "moment";
import styles from "./style.module.css";
const OptimizeConfigureButton = ({ predict }) => {
    const dispatch = useDispatch();
    const reportId = predict?.reportId;
    const updatedDate = predict?.updatedDate
        ? moment.utc(predict?.updatedDate).local().format("MMMM Do YYYY, h:mm:ss a")
        : undefined;
    const [isFetchingReport, updateIsFetchingReport] = useState(false);
    const report = useSelector((state) => {
        if (!reportId) {
            return undefined;
        }
        return reportReducer.getReport(state, reportId);
    });
    const fetchReport = async (reportId) => {
        updateIsFetchingReport(true);
        try {
            await dispatch(reportReducer.fetchReport(reportId));
        }
        catch {
            console.log("Report could not be fetched.");
            updateIsFetchingReport(false);
        }
        updateIsFetchingReport(false);
    };
    useEffect(() => {
        if (reportId && !report && !isFetchingReport) {
            fetchReport(reportId);
        }
    }, []);
    const reportDatasetId = report?.metadata?.explorations?.[0]?.datasetId;
    if (!report) {
        React.createElement("div", { className: "flex items-center" },
            React.createElement(Button, { onClick: () => fetchReport(reportId), style: { padding: "6px 8px", marginRight: "8px" }, isLoading: isFetchingReport }, "Fetch Project Details"));
    }
    return (React.createElement("div", { className: "flex items-center" },
        React.createElement(Button, { onClick: () => window.open("/next/" + reportDatasetId + "/" + report?.id + "?scrollToSection=OPTIMIZE"), style: { padding: "6px 8px", marginRight: "8px" }, isLoading: isFetchingReport }, "Configure - " + report?.name),
        updatedDate && React.createElement("div", { className: styles.predictDateInfo }, `Generated from data updated: ${updatedDate}`)));
};
export default OptimizeConfigureButton;
